<template>
  <div class="dialog-header">
    <icon v-if="!noIcon" :type="this.type" />
    <div>
      <h1 v-if="text">{{text}}</h1>
      <p class="m-0" v-if="description">{{description}}</p>
    </div>
  </div>
</template>

<script>
import icon from "../components/Icon.vue";

export default {
  name: "dialog-header",
  components: {
    icon
  },
  props: {
    text: String,
    description: String,
    type: String,
    noIcon: Boolean
  }
}
</script>
